import { Component, input } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { ContractInfoComponent } from './contract-info/contract-info.component';
import { Contract } from 'app/shared/models/contract.model';
import { Organisation } from 'app/shared/models/organisation.model';

@Component({
  selector: 'ez-payment-details',
  imports: [ContractInfoComponent, CurrencyPipe],
  templateUrl: './payment-details.component.html',
  styleUrl: './payment-details.component.scss',
})
export class PaymentDetailsComponent {
  readonly organisation = input.required<Organisation>();
  readonly totalAmount = input.required<number>();
  readonly contracts = input.required<Contract[]>();

  isHidden = true;
  visibility = 'hidden';
  buttonText = 'Mehr Details';

  toggleDetailsVisibility() {
    if (this.isHidden) {
      this.isHidden = false;
      this.visibility = 'visible';
      this.buttonText = 'Weniger Details';
    } else {
      this.isHidden = true;
      this.visibility = 'hidden';
      this.buttonText = 'Mehr Details';
    }
  }
}
